import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Sparkles, Heart, Flower2, Link2, Rainbow, ArrowRight, Plus } from "lucide-react";

const TILES = [
  { name: "Escort", icon: Heart, text: "Gezelschap en ontmoetingen" },
  { name: "Massage & wellness", icon: Flower2, text: "Ontspanning en sensuele massage" },
  { name: "SM & Fetish", icon: Link2, text: "Meesteressen, meesters en kinks" },
  { name: "Gay en trans", icon: Rainbow, text: "Diensten van en voor iedereen" },
];

export default function ServicesPromo() {
  const [stats, setStats] = useState({ total: 0, today: 0 });

  useEffect(() => {
    api.get("/products", { params: { type: "service" } })
      .then(({ data }) => setStats({ total: data.length, today: data.filter((s) => s.available_today).length }))
      .catch(() => {});
  }, []);

  return (
    <section data-testid="services-promo" className="border-b border-zinc-800/60 bg-gradient-to-b from-rose-950/30 to-zinc-950">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-14">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-8">
          <div className="max-w-xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-rose-600 px-3 py-1 font-mono text-[11px] uppercase tracking-widest text-white">
              <Sparkles className="h-3.5 w-3.5" /> Nieuw op Fetshop
            </span>
            <h2 className="mt-4 font-serif text-3xl sm:text-4xl font-semibold text-zinc-100">
              Niet alleen spullen, ook <span className="italic text-rose-400">diensten</span>
            </h2>
            <p className="mt-3 text-sm sm:text-base text-zinc-400">
              Vind escorts, sensuele massages, SM- en fetishdiensten bij jou in de buurt. Bied je zelf iets aan? Plaats je dienst nu <strong className="text-rose-300">gratis</strong>.
            </p>
            {stats.total > 0 && (
              <div className="mt-4 flex flex-wrap gap-4 text-sm">
                <span data-testid="services-promo-total" className="text-zinc-300"><span className="font-mono text-rose-400">{stats.total}</span> diensten online</span>
                {stats.today > 0 && (
                  <span data-testid="services-promo-today" className="flex items-center gap-2 text-emerald-300">
                    <span className="h-2 w-2 rounded-full bg-emerald-400 animate-pulse" /> {stats.today} vandaag beschikbaar
                  </span>
                )}
              </div>
            )}
          </div>
          <div className="flex flex-wrap gap-3">
            <Link to="/diensten" data-testid="services-promo-browse" className="flex items-center gap-2 rounded-full bg-rose-600 hover:bg-rose-500 px-6 py-3 text-sm font-medium text-white transition-colors">
              Bekijk alle diensten <ArrowRight className="h-4 w-4" />
            </Link>
            <Link to="/dienst-plaatsen" data-testid="services-promo-create" className="flex items-center gap-2 rounded-full border border-rose-700 hover:bg-rose-950/60 px-6 py-3 text-sm font-medium text-rose-200 transition-colors">
              <Plus className="h-4 w-4" /> Dienst gratis aanbieden
            </Link>
          </div>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
          {TILES.map(({ name, icon: Icon, text }) => (
            <Link key={name} to={`/diensten?categorie=${encodeURIComponent(name)}`} data-testid={`services-promo-tile-${name}`}
              className="group rounded-2xl border border-zinc-800 bg-zinc-900/60 p-4 sm:p-5 hover:border-rose-700 hover:bg-rose-950/30 transition-colors">
              <Icon className="h-6 w-6 text-rose-400 transition-transform group-hover:scale-110" />
              <div className="mt-3 font-medium text-zinc-100">{name}</div>
              <div className="mt-1 text-xs text-zinc-500">{text}</div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
